export const bossEnv = window.BOSS_ENV;


export const getApiConfig = (key, configObjectName = 'bossCommonEnv') => {
  if (!key) {
      return '';
  }
  let prefix = undefined;
  if (window[configObjectName]) {
      prefix = window[configObjectName][key];
  }
  if (prefix === undefined || prefix === null) {
      prefix = window.apmCommonEnv[key];
  }
  return prefix;
};

// 接口前缀 在腾讯云ConfigMap中进行配置
export const accountPrefix = getApiConfig('INTERFACE_PREFIX_ACCOUNT');
export const authPrefix = getApiConfig('INTERFACE_PREFIX_AUTH');
export const communalPrefix = getApiConfig('INTERFACE_PREFIX_COMMUNAL');